module.exports = __webpack_public_path__ + "static/emsi-logo-8cf99f5e00c24a8dda46d847869d733f.png";